// 每次请求前都要携带token 如果不带，服务器会报401的错误
import axios from 'axios'

let http = axios.create({
    timeout:10000,
	baseURL: 'http://chengqifu.com/index.php/',
	// baseURL: '/api',
	method: 'POST',
})
// 请求拦截---每次发起请求之前判断是否有token
export default http
